<div class="p-6">
  <mat-expansion-panel
    [expanded]="isOpen"
    hideToggle
    [class.compact-layout]="compactLayout"
  >
    <mat-expansion-panel-header (click)="toggleContent()">
      <div class="flex justify-between items-center w-full">
        <div class="flex items-center">
          @if (icon) {
            <fa-icon [icon]="icon" class="text-[15px] mr-3 pb-[2px]"></fa-icon>
          }
          <div class="setting-name">{{ name }}</div>

          @if (tag) {
            <span class="setting-tag">{{ tag | translate }}</span>
          }
        </div>

        <div class="flex items-center gap-3">
          <ng-content select="[headerActions]"></ng-content>
          <fa-icon
            class="text-sm opacity-50"
            [icon]="'chevron-down'"
            [class.rotated]="isOpen"
          ></fa-icon>
        </div>
      </div>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
  </mat-expansion-panel>
</div>
